import React, { useEffect, useState } from 'react';
import { AppBar, Box, Toolbar, IconButton, Typography, Badge } from '@mui/material';
import { Menu, Notifications } from '@mui/icons-material';
// import { useNavigate } from 'react-router-dom';
// import Logout from '../auth/Logout';
import DrawerMenu from '../drawers/DrawerMenu';
import { Actions, useDispatchProvider, useStateHeader } from './StateProvider';
import SnackbarAlert from './SnackbarAlert';
import DialogDelete from '../dialogs/DialogDelete';
import DialogProduct from '../dialogs/DialogProduct';
import DrawerOrder from '../drawers/DrawerOrder';
import DialogCustomer from '../dialogs/DialogCustomer';
import DrawerUser from '../drawers/DrawerUser';
import DrawerCustomer from '../drawers/DrawerCustomer';
import DialogTransaction from '../dialogs/DialogTransaction';
import DrawerNotifications from '../drawers/DrawerNotifications';
import { usePermissions } from './AclProvider';
// import logo from '../../assets/logo.png';

const Layout = ({ children }) => {
  const dispatch = useDispatchProvider();
  const permissions = usePermissions();
  const stateHeader = useStateHeader();
  const [notifications, setNotifications] = useState(0);
  // const navigate = useNavigate();

  const toggleDrawerMenu = (newOpen) => () => {
    dispatch && dispatch({ type: Actions.DrawerMenu, payload: true });
  };

  const toggleDrawerNotifications = (newOpen) => () => {
    dispatch && dispatch({ type: Actions.DrawerNotifications, payload: true });
  };

  useEffect(() => {
    const calculateNotifications = () => {
      setNotifications(parseInt(stateHeader.notifications.backorders) + parseInt(stateHeader.notifications.shipping));
    };
    calculateNotifications();
  }, [stateHeader.notifications.backorders, stateHeader.notifications.shipping]);

  // const navigateToDashboard = () => () => {
  //   navigate('/dashboard');
  // };

  return (
    <Box
      className={'MuiBox-layout'}
      sx={{ display: 'flex', flexDirection: 'column', height: '100dvh' }}
    >
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={toggleDrawerMenu(true)}
          >
            <Menu />
          </IconButton>
          {/*<IconButton*/}
          {/*  size="large"*/}
          {/*  color="inherit"*/}
          {/*  aria-label="logo"*/}
          {/*  sx={{ mr: 2 }}*/}
          {/*  onClick={navigateToDashboard}*/}
          {/*>*/}
          {/*  <img src={logo} />*/}
          {/*</IconButton>*/}
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
          >
            Warehouse
          </Typography>
          <Typography
            variant={'body1'}
            component={'div'}
            color={'textSecondary'}
          >
            v1.20.0
          </Typography>
          {permissions.products.delete && (
            <IconButton
              size="large"
              edge="end"
              color="inherit"
              aria-label="Notifications"
              sx={{ ml: 2 }}
              onClick={toggleDrawerNotifications(true)}
            >
              <Badge
                badgeContent={notifications}
                color={'primary'}
              >
                <Notifications />
              </Badge>
            </IconButton>
          )}
          {/*<Logout />*/}
        </Toolbar>
      </AppBar>
      <Box
        component={'main'}
        display={'flex'}
        flexDirection={'column'}
        sx={{ flexGrow: 1, p: 3, pb: 0, overflow: 'hidden' }}
      >
        {children}
      </Box>
      <DrawerMenu />
      {permissions.products.delete && <DrawerNotifications />}
      <DrawerOrder />

      <DialogDelete />
      <DialogProduct />
      <DialogCustomer />
      <DialogTransaction />
      <DrawerUser />
      <DrawerCustomer />
      <SnackbarAlert />
    </Box>
  );
};

export default Layout;
